import Tippy from '@tippyjs/react';

import Icon from 'components/shared/Icon/Icon';

export const findPropertyByValue = (array, value) => {
  const foundItem = array?.find((item) => item?.value === value);
  return foundItem;
};

export const formatProviderOptionLabel = (option, { context }) => {
  const { label, type } = option;

  // When displaying as selected value (tag/chip), show only the label
  if (context === 'value') {
    return label;
  }

  return (
    <div className="flex w-full items-center justify-between">
      <span>{label}</span>
      <span className="text-sm">{type === 'billing' ? 'Billing' : 'Rendering'} provider</span>
    </div>
  );
};

export const getLabel = (label, tooltip) => {
  return (
    <div className="flex w-full justify-between">
      <span>{label}</span>
      <Tippy content={tooltip} className="tippy-dark" arrow>
        <div className="flex">
          <Icon icon="info-mono" />
        </div>
      </Tippy>
    </div>
  );
};

export const getInitialValues = ({ externalInitialValues }) => {
  if (externalInitialValues) {
    return externalInitialValues;
  }

  return {
    name: '',
    phone: '',
    address_ln_1: '',
    address_ln_2: '',
    city: '',
    state: null,
    zip: '',
    type: '',
    virtual_modifiers: [],
    in_network_providers: [],
    out_of_network_providers: []
  };
};
